/** This export is automatically generated */
export const gitHash = '5799655bb';
